import { Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { ITitle } from "src/types/global";
const TitlePaper = ({
  title,
  subtitle
}: ITitle) => {
  return <>
      <Typography color={grey[700]} fontWeight={700} marginBottom={1}>
        {title}
      </Typography>
      <Typography color={grey[600]}>{subtitle}</Typography>
    </>;
};
export default TitlePaper;